import React, { Component } from 'react'
import cloudItemsStore from '../../stores/cloudItemsStore'
import history from '../common/history.js'
import { inject, observer } from 'mobx-react'

@inject('filtersStore')
@observer
class ProductFilter extends Component {
  toggleActive = () => {
    const { filtersStore } = this.props

    cloudItemsStore.reset();
    this.props.toggle.apply(filtersStore);
    let params = filtersStore.toParams();
    history.push(`${window.location.pathname}?${params}`);
  }

  render() {
    return (
      <button
        onClick={this.toggleActive}
        className={`rounded-[17px] px-2.5 text-gray-15 h-[22px] text-sm items-center ${this.props.active ? 'bg-orange-1' : 'bg-gray-3'}`}
      >
        <div className='flex'>
          { this.props.img && <img src={this.props.img} /> }
          {
            this.props.children && (
              <span className='ml-0.5'>{this.props.children}</span>
            )
          }
        </div>
      </button>
    )
  }
}

export default ProductFilter
